import { createAsyncThunk } from '@reduxjs/toolkit';
import rootAxios from '../../requests/rootAxios';
import { setReportType } from '../../reducer/trainingReportsSlice';

const Base_url = process.env.REACT_APP_BASE_URL;
const reportTypeMap = {
  raw: '/super-user/get-trainee-report-data',
  pendency: '/user/get-pendency-reports',
  absenteeism: '/user/get-absentees-reports',
  absdnjres: '/user/get-absconding-dnj-resigned-employees',
  nomination: '/user/get-nomination-reports',
  trainerwise: '/user/get-trainer-wise-reports',
  clusterwise: '/user/get-cluster-trainer-wise-reports',
  monthly: '/user/get-trainer-wise-reports',
  traininglog: '/user/get-employee-training-log-report',
};
export const fetchTrainingReportData = createAsyncThunk(
  'trainingReports/fetchTrainingReportData',
  async (params, { dispatch, rejectWithValue }) => {
    try {
      // Handle both old format (string) and new format (object)
      const reportType = typeof params === 'string' ? params : params.reportType;
      const payload = typeof params === 'string' ? {} : params.payload || {};

      // Set the report type in the store
      console.log('reportType', reportType);
      dispatch(setReportType(reportType));

      const response = await rootAxios.post(`${Base_url}${reportTypeMap[reportType]}`, payload);
      console.log('returning data of length', response?.data?.data?.data?.length);
      return response?.data?.data?.data || [];
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);
